import React, { Component } from 'react';
import './LoadingOverlay.css';

// Props
// isOpen: boolean

export default class LoadingOverlay extends Component {

  render() {
    if (this.props.isOpen) {
      return (
        <div className={'LoadingOverlay'}>
          <div className={'LoadingOverlay-content'}>
            <img alt={'LoadingOverlay'} className={'LoadingOverlay-image'} src={`${process.env.PUBLIC_URL}/images/Spinner.gif`} />
          </div>
        </div>
      );
    }
    else {
      return null;
    }
  }
}
